<script lang="ts">
    import { appManager } from "../AppManager";
    import {
        Collapse,
        Navbar,
        NavbarToggler,
        Nav,
        NavItem,
        NavLink,
        Dropdown,
        DropdownToggle,
        DropdownMenu,
        Row,
        Col,
    } from "sveltestrap";
    import { ListGroup, ListGroupItem } from "sveltestrap";
    import { _ } from "svelte-i18n";
    import {
        Logo,
        ShortCutLogo,
        ImpactLogo,
        ReRouteLogo,
        Database,
        Bicycle,
    } from "@anyways-open/common-svgs";
    import LanguageSwitchAlert from "./language/LanguageSwitchAlert.svelte";
    import type { UserData } from "@anyways-open/identity-api-client";
    import { get } from "svelte/store";
    import NotOnDesktopAlert from "./warning/NotOnDesktopAlert.svelte";
    import PlanAlert from "./plans/PlanAlert.svelte";

    export let isDark: boolean = true;
    export let isFluid: boolean = true;

    let user: UserData;

    let firstName = "";
    $: if (typeof user !== "undefined" && 
        typeof user.firstName !== "undefined") {
            firstName = user.firstName ?? "";
        }

    let isOpen = false;
    function handleUpdate(event) {
        //isOpen = event.detail.isOpen;
    }

    function toggleOpen() {
        isOpen = !isOpen;
    }

    const getUser = async () => {
        const store = await appManager.getCurrentUserStore();
        store.subscribe((currentUser) => {
            user = currentUser;
        });
        user = get(store);
    };
</script>

<LanguageSwitchAlert />

<NotOnDesktopAlert />

<PlanAlert />

{#await getUser() then}
    <Navbar
        class="navbar navbar-expand-lg {isDark
            ? 'bg-dark'
            : 'navbar-light'} bg-white border-bottom"
        container={isFluid}>
        {#if user}
            <h4>
                <a
                    class="icon footer-brand img-fluid pr-2"
                    href={appManager.PublicUrl}>
                    <Logo />
                </a> ANYWAYS
            </h4>
        {:else}
            <h4>
                <a
                    class="icon footer-brand img-fluid pr-2"
                    href={appManager.RootUrl}>
                    <Logo />
                </a> ANYWAYS
            </h4>
        {/if}

        <NavbarToggler on:click={() => toggleOpen()} />

        <Collapse {isOpen} navbar expand="lg" on:update={handleUpdate}>
            <Nav class="ms-auto" navbar>
                <NavbarToggler on:click={() => toggleOpen()}>
                    <i class="fe fe-x" />
                </NavbarToggler>

                <NavItem>
                    <NavLink href="https://docs.anyways.eu" target="_blank"
                        >{$_("general.documentation")}</NavLink>
                </NavItem>

                {#if user}
                    <div
                        class="btn-group"
                        role="group"
                        aria-label="Basic example">
                        <a
                            class="navbar-btn btn btn-sm btn-primary"
                            href="{appManager.RootUrl}settings"
                            data-smooth-scroll>
                            {$_("menu.account")}
                        </a>
                    </div>
                {:else}

                    <div class="btn-group">
                        <a
                            class="navbar-btn btn btn-sm btn-primary"
                            href="{appManager.RootUrl}signup?redirect={appManager.PublicUrl}"
                            >{$_("menu.signup")}</a>
                        <a
                            class="navbar-btn btn btn-sm btn-outline-primary"
                            href="{appManager.RootUrl}signin?redirect={appManager.PublicUrl}"
                            >{$_("menu.signin")}</a>
                    </div>
                {/if}
            </Nav>
        </Collapse>
    </Navbar>
{/await}

<style>
</style>
